import {
  checkAccessToken,
  checkAccount,
  checkBrandService,
  checkLayerWrapper,
  closePopup,
  createLayer,
  customizeStyle,
  getIframe,
  getIframeById,
  initLayer,
  layerResize,
  removeLayer,
} from './helpers';
import { setEnableBackControl } from './utils/back-control';
import { spinnerStart, spinnerStop } from './utils/spinner';
import AccountArsAuth from './views/pages/account-ars-auth';
import AccountAuth from './views/pages/account-auth';
import AccountRegi from './views/pages/account-regi';
import AccountRegiComplete from './views/pages/account-regi-complete';
import AccountRemitc from './views/pages/account-remitc';
import AgreeOpenBanking from './views/pages/agree-open-banking';
import CardRegi from './views/pages/card-regi';
import CardRegiCallback from './views/pages/card-regi-callback';
import CardRegiClose from './views/pages/card-regi-close';
import CardRegiComplete from './views/pages/card-regi-complete';
import CashReceipt from './views/pages/cash-receipt';
import ChargDeposit from './views/pages/charg-deposit';
import ChargDepositAuto from './views/pages/charg-deposit-auto';
import ChargDepositComplete from './views/pages/charg-deposit-complete';
import ChargDetails from './views/pages/charg-details';
import ChargRemitc from './views/pages/charg-remitc';
import ChargRemitcUid from './views/pages/charg-remitc-uid';
import EnterPwd from './views/pages/enter-pwd';
import KmcertCallback from './views/pages/kmcert-callback';
import OnlinePay from './views/pages/online-pay';
import OnlinePayComplete from './views/pages/online-pay-complete';
import OnsitePay from './views/pages/onsite-pay';
import PayMethod from './views/pages/pay-method';
import PaymentDetails from './views/pages/payment-details';
import PaymentDetails2 from './views/pages/payment-details2';
import RemitcComplete from './views/pages/remitc-complete';
import resetPassStep1 from './views/pages/reset-pass-step1';
import resetPassStep2 from './views/pages/reset-pass-step2';
import ResultPage from './views/pages/result-page';
import Settings from './views/pages/settings';
import Terms from './views/pages/terms';
import TermsView from './views/pages/terms-view';

export const routes = {
  close: {
    hashPath: '#close',
    component: null,
  },
  kmcertCallback: {
    hashPath: '#conpay_kmcert-callback',
    component: KmcertCallback,
  },
  settings: {
    hashPath: '#conpay_settings',
    component: Settings,
  },
  payMethod: {
    hashPath: '#conpay_pay-method',
    component: PayMethod,
  },
  cardRegi: {
    hashPath: '#conpay_card-regi',
    component: CardRegi,
  },
  cardRegiCallback: {
    hashPath: '#conpay_card-regi-callback',
    component: CardRegiCallback,
  },
  cardRegiClose: {
    hashPath: '#conpay_card-regi-close',
    component: CardRegiClose,
  },
  cardRegiComplete: {
    hashPath: '#conpay_card-regi-complete',
    component: CardRegiComplete,
  },
  enterPwd: {
    hashPath: '#conpay_enter-pwd',
    component: EnterPwd,
  },
  accountRegi: {
    hashPath: '#conpay_account-regi',
    component: AccountRegi,
  },
  accountAuth: {
    hashPath: '#conpay_account-auth',
    component: AccountAuth,
  },
  accountArsAuth: {
    hashPath: '#conpay_account-ars-auth',
    component: AccountArsAuth,
  },
  accountRegiComplete: {
    hashPath: '#conpay_account-regi-complete',
    component: AccountRegiComplete,
  },
  onlinePay: {
    hashPath: '#conpay_online-pay',
    component: OnlinePay,
  },
  onlinePayComplete: {
    hashPath: '#conpay_online-pay-complete',
    component: OnlinePayComplete,
  },
  onsitePay: {
    hashPath: '#conpay_onsite-pay',
    component: OnsitePay,
  },
  cashReceipt: {
    hashPath: '#conpay_cash-receipt',
    component: CashReceipt,
  },
  agreementOpenBanking: {
    hashPath: '#conpay_agreement-open-banking',
    component: AgreeOpenBanking,
  },
  chargDeposit: {
    hashPath: '#conpay_charg-deposit',
    component: ChargDeposit,
  },
  chargDepositComplete: {
    hashPath: '#conpay_charg-deposit-complete',
    component: ChargDepositComplete,
  },
  chargDepositAuto: {
    hashPath: '#conpay_charg-deposit-auto',
    component: ChargDepositAuto,
  },
  chargDetails: {
    hashPath: '#conpay_charg-details',
    component: ChargDetails,
  },
  paymentDetails: {
    hashPath: '#conpay_payment-details',
    component: PaymentDetails,
  },
  terms: {
    hashPath: '#conpay_terms',
    component: Terms,
  },
  termsView: {
    hashPath: '#conpay_terms-view',
    component: TermsView,
  },
  accountRemitc: {
    hashPath: '#conpay_account-remitc',
    component: AccountRemitc,
  },
  chargRemitc: {
    hashPath: '#conpay_charg-remitc',
    component: ChargRemitc,
  },
  chargRemitcUid: {
    hashPath: '#conpay_charg-remitc-uid',
    component: ChargRemitcUid,
  },
  paymentDetails2: {
    hashPath: '#conpay_payment-details2',
    component: PaymentDetails2,
  },
  remitcComplete: {
    hashPath: '#conpay_remitc-complete',
    component: RemitcComplete,
  },
  resultPage: {
    hashPath: '#conpay_result-page',
    component: ResultPage,
  },
  resetPassStep1: {
    hashPath: '#conpay_reset-pass-step1',
    component: resetPassStep1,
  },
  resetPassStep2: {
    hashPath: '#conpay_reset-pass-step2',
    component: resetPassStep2,
  },
};

export const router = async (event, cb = () => {}) => {
  const { routePath, query, state } = parseRequestUrl();
  const page = Object.values(routes).find(
    (route) => route.hashPath === routePath
  );

  if (
    page === undefined ||
    page === null ||
    page.hashPath == routes.close.hashPath
  ) {
    closePopup();
    return;
  }

  // 토큰 확인
  const check1 = await checkAccessToken(routePath);
  if (!check1.isSatisfied) {
    replaceRouter({ message: check1.message }, null, check1.hashPath);
    return;
  }

  // 브랜드 신청서비스 확인
  const check2 = checkBrandService(routePath);
  if (!check2.isSatisfied) {
    replaceRouter({ message: check2.message }, null, check2.hashPath);
    return;
  }

  // 계좌등록여부 확인
  const check3 = await checkAccount(routePath);
  if (!check3.isSatisfied) {
    replaceRouter({ message: check3.message }, null, check3.hashPath);
    return;
  }

  if (!checkLayerWrapper()) {
    removeLayer();
  }
  createLayer();
  initLayer();
  spinnerStart(true);
  customizeStyle();
  getIframe().getElementById('layer-wrapper').innerHTML =
    await page.component.render();
  // getIframeById().contentWindow.focus();
  layerResize();
  await page.component.afterRender(query, state);
  setEnableBackControl();
  cb();
  spinnerStop();
};

export const parseRequestUrl = () => {
  const url = new URL(window.location.href);
  const routePath = url.hash.split('?')[0];
  const search = url.hash.split('?')[1];
  const query = new URLSearchParams(search);
  const state = history.state;

  return {
    routePath,
    query,
    state,
  };
};

export const pushRouter = (state, title, url, cb = () => {}) => {
  if (routes.close.hashPath === url) {
    closePopup();
    return;
  }

  const currentUrl = new URL(window.location.href);
  const path = currentUrl.pathname.includes('#')
    ? currentUrl.pathname.split('#')[0] + url
    : currentUrl.pathname + url;

  history.pushState(state, title, path);
  router(null, cb);
};

export const replaceRouter = (state, title, url, cb = () => {}) => {
  if (routes.close.hashPath === url) {
    closePopup();
    return;
  }

  history.replaceState(state, title, url);
  router(null, cb);
};
